import LayoutGestao from './layouts/Main.vue'
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';
import ModuleMixin from './shared/mixins/ModuleMixin';
import ManageStoreMixin from './shared/mixins/ManageStoreMixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [
        BaseGestaoMixin,
        ModuleMixin,
        ManageStoreMixin,
    ],
    components: {
        LayoutGestao,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'loading',
        }),
    },
    methods: {
        setLoading(flag) {
            this.$store.dispatch('setLoading', flag);
        }
    }
}
